import React from 'react';
import { Link } from 'react-router-dom';

import { PhosphorIcon, PHOSPHOR_PATHS } from '../../users/conversation_room/phosphor_icons';
import shellStyles from '../../users/conversation_room/unified_layout.module.css';
import styles from '../new_settings.module.css';
import { ICON_PATHS, Icon } from './icons';
import { Row, Section } from './sections';

const CATEGORIES = [{ key: 'account', label: 'Account', icon: ICON_PATHS.user }];

export function activeKeyFromPath(pathname) {
  if (pathname.includes('/privacy')) return 'privacy';
  if (pathname.includes('/account')) return 'account';
  return null;
}

export function BottomNav({ isPhoneCallsEnabled }) {
  return (
    <nav className={shellStyles.mobile_bottom_nav} aria-label='Member navigation'>
      <Link to='/member/conversations' className={shellStyles.mobile_bottom_nav_item}>
        <span className={shellStyles.mobile_bottom_nav_pill}>
          <span className={shellStyles.mobile_bottom_nav_icon}>
            <PhosphorIcon path={PHOSPHOR_PATHS.chatCircle.regular} size={24} />
          </span>
          <strong>Messages</strong>
        </span>
      </Link>
      {isPhoneCallsEnabled && (
        <Link to='/member/calls' className={shellStyles.mobile_bottom_nav_item}>
          <span className={shellStyles.mobile_bottom_nav_pill}>
            <span className={shellStyles.mobile_bottom_nav_icon}>
              <PhosphorIcon path={PHOSPHOR_PATHS.phone.regular} size={24} />
            </span>
            <strong>Calls</strong>
          </span>
        </Link>
      )}
      <Link
        to='/member/settings'
        className={`${shellStyles.mobile_bottom_nav_item} ${shellStyles.mobile_bottom_nav_item_active}`}
      >
        <span className={shellStyles.mobile_bottom_nav_pill}>
          <span className={shellStyles.mobile_bottom_nav_icon}>
            <PhosphorIcon path={PHOSPHOR_PATHS.gear.fill} size={24} />
          </span>
          <strong>Settings</strong>
        </span>
      </Link>
    </nav>
  );
}

export function Rail({ activeKey, onSelect, onSignOut }) {
  return (
    <aside className={styles.rail}>
      <h1 className={styles.rail_title}>Settings</h1>
      <nav className={styles.rail_nav}>
        {CATEGORIES.map((category) => {
          const active = category.key === activeKey;
          return (
            <button
              key={category.key}
              type='button'
              className={`${styles.rail_item} ${active ? styles.rail_item_active : ''}`}
              onClick={() => onSelect(category.key)}
            >
              {active && <span className={styles.rail_active_bar} />}
              <span className={styles.rail_icon}>
                <Icon path={category.icon} size={16} />
              </span>
              <span>{category.label}</span>
            </button>
          );
        })}
      </nav>
      <div className={styles.rail_signout}>
        <button type='button' className={styles.rail_item} onClick={onSignOut}>
          <span className={styles.rail_icon}>
            <Icon path={ICON_PATHS.signout} size={14} />
          </span>
          <span>Sign out</span>
        </button>
      </div>
    </aside>
  );
}

export function MobileHub({ onSelect, onSignOut }) {
  const mobileRows = [
    {
      key: 'account',
      label: 'Account',
      sub: 'Name, email, password',
      icon: ICON_PATHS.user,
    },
  ];

  return (
    <div className={`${styles.mobile_hub} ${styles.motion_stack}`}>
      <h1 className={`${styles.mobile_hub_title} ${styles.motion_item}`}>Settings</h1>
      <Section className={styles.motion_item}>
        {mobileRows.map((row) => (
          <Row key={row.key} icon={row.icon} label={row.label} sub={row.sub} onClick={() => onSelect(row.key)} />
        ))}
      </Section>
      <Section className={styles.motion_item}>
        <Row icon={ICON_PATHS.signout} label='Sign out' onClick={onSignOut} />
      </Section>
      <p className={`${styles.mobile_version} ${styles.motion_item}`}>PatientPartner v1.0.0</p>
    </div>
  );
}

export function pathForSection(key, isMobile) {
  if (key === 'account') return isMobile ? '/member/settings/account' : '/member/settings';
  return `/member/settings/${key}`;
}
